import { createContext, useCallback, useEffect, useMemo, useState } from "react";
import { subscribeToNetworkStatus } from "../lib/networkStatus";

const defaultStatus = {
  offline: false,
  message: "",
  lastErrorAt: null,
};

export const NetworkStatusContext = createContext({
  ...defaultStatus,
  retry: () => {},
});

export const NetworkStatusProvider = ({ children }) => {
  const [status, setStatus] = useState(defaultStatus);

  useEffect(() => {
    const unsubscribe = subscribeToNetworkStatus((nextStatus) => {
      setStatus(nextStatus);
    });

    return unsubscribe;
  }, []);

  const retry = useCallback(() => {
    window.location.reload();
  }, []);

  const value = useMemo(
    () => ({
      ...status,
      retry,
    }),
    [status, retry]
  );

  return (
    <NetworkStatusContext.Provider value={value}>
      {children}
    </NetworkStatusContext.Provider>
  );
};

